import CloseIcon from '../../assets/img/custom/close.svg';

const AppMobileMenu = ({ menu }) => {
  return (
    <div
      className="offcanvas mobile-menu "
      tabIndex="-1"
      id="appMobileMenu"
      aria-labelledby="appMobileMenuLabel"
      data-bs-backdrop="false"
    >
      <div className="offcanvas-body h-100 w-100 p-0">
        <div className="d-flex justify-content-end p-3">
          <button
            className="close-mobile-menu-button"
            type="button"
            data-bs-toggle="offcanvas"
            data-bs-target="#appMobileMenu"
            aria-controls="appMobileMenu"
            aria-label="Close"
          >
            <img src={CloseIcon} alt="close" />
          </button>
        </div>

        <div className="menubar d-block bg-white position-relative h-100 w-100">
          <ul className="menu accordion">{menu()}</ul>
        </div>
      </div>
    </div>
  );
};

export default AppMobileMenu;
